import { useTranslation } from "react-i18next";
import SVG from "react-inlinesvg";

import { useMobile } from "@krea/customer-features/hooks";
import { Text } from "@krea/customer-features/shared-components/text";
import { ILenderResponseBenefit } from "@krea/customer-features/types/lenderResponse";
import { getBenefits } from "@krea/customer-features/utils";
import twMerge from "@krea/customer-features/utils/tailwind-utils";

interface IBidBenefits {
  benefits: ILenderResponseBenefit[];
  isCondensedVersion?: boolean;
}

const BidBenefits = ({ benefits, isCondensedVersion }: IBidBenefits) => {
  const { t } = useTranslation();
  const isMobile = useMobile();
  const relevantBenefits = isCondensedVersion
    ? getBenefits(benefits).slice(0, 2)
    : getBenefits(benefits);

  const getBenefitText = (benefit: ILenderResponseBenefit) => {
    if (isCondensedVersion) return benefit.displayName;
    if (benefit.explanation) return benefit.explanation;

    return benefit.displayName;
  };

  return relevantBenefits.length > 0 ? (
    <div
      className={twMerge("tw-mt-2 tw--mx-1", {
        "tw-min-w-[200px]": isCondensedVersion,
      })}
    >
      {!isCondensedVersion && !isMobile && (
        <Text size="md" className="tw-mb-4 tw-font-bold tw-text-gray-600">
          {t("bidDetails.benefits")}
        </Text>
      )}

      <ul
        className={twMerge("tw-list-none", {
          "tw-border tw-border-solid tw-border-krea-warm-gray tw-bg-white tw-p-3 tw-rounded-md":
            isMobile,
          "tw-m-0 tw-p-0": !isMobile,
        })}
      >
        {relevantBenefits.map(
          (benefit, index) =>
            benefit.icon &&
            benefit.displayName && (
              <li
                key={index}
                className={twMerge("tw-flex tw-items-center", {
                  "tw-my-3": !isCondensedVersion && !isMobile,
                  "tw-truncate": isCondensedVersion,
                })}
              >
                <div className="tw-relative tw-mr-2 tw-h-[18px] tw-w-[18px] tw-shrink-0">
                  <SVG
                    src={benefit.icon}
                    className="tw-absolute tw-left-0 tw-top-0 tw-h-auto tw-w-full"
                  />
                </div>

                <Text size={isMobile ? "xs" : "sm"} className="tw-mb-0">
                  {getBenefitText(benefit)}
                </Text>
              </li>
            ),
        )}
      </ul>
    </div>
  ) : null;
};

export default BidBenefits;
